
import { Ball, SimulationConfig } from '@/types';

export const DrawerLogic = {
  updateBall: (b: Ball, config: SimulationConfig, now: number, stepTS: number) => {
      if (!config.enableDrawer) return;

      b.trailAccumulator = (b.trailAccumulator || 0) + stepTS;
      const interval = config.drawerPointFrequency || 1.0;
      const maxLength = config.drawerMaxLength || 1000;
      
      const shouldRecord = !config.drawerOnlyOnBounce || b.justBounced;

      if (b.trailAccumulator >= interval && shouldRecord) {
          b.trailAccumulator = 0;
          if (!b.hitPoints) b.hitPoints = [];
          
          const speed = Math.sqrt(b.vel.x**2 + b.vel.y**2);
          
          b.hitPoints.push({
              pos: { x: b.pos.x, y: b.pos.y },
              time: now,
              velocity: speed,
              color: b.color,
              thickness: config.drawerLineThickness,
              opacity: config.drawerLineOpacity
          });
          if (b.hitPoints.length > maxLength) b.hitPoints.shift();
      }

      if (config.drawerLineDecay && b.hitPoints) {
          const lifetime = (config.drawerLineLifetime || 5) * 1000;
          while (b.hitPoints.length > 0 && now - b.hitPoints[0].time > lifetime) {
              b.hitPoints.shift();
          }
      }
      
      b.justBounced = false;
  },

  manageGlobal: (balls: Ball[], config: SimulationConfig, now: number) => {
      if (!config.enableDrawer) return;

      if (config.drawerAutoClearInterval > 0) {
          const lastClear = (window as any).lastDrawerClearTime || now;
          if (now - lastClear > config.drawerAutoClearInterval * 1000) {
              (window as any).lastDrawerClearTime = now;
              balls.forEach(b => { b.hitPoints = []; });
          }
      }

      if (config.drawerAttractionMode !== 'NONE') {
          const strength = config.drawerAttractionStrength || 0.05;
          const radiusSq = (config.drawerAttractionRadius || 100)**2;
          const repulsion = config.drawerAttractionMode === 'REPEL' ? -1 : 1;

          balls.forEach(b => {
              balls.forEach(otherB => {
                  if (!otherB.hitPoints) return;
                  // Sampling for performance
                  for (let i = 0; i < otherB.hitPoints.length; i += 5) {
                      const p = otherB.hitPoints[i];
                      const dx = p.pos.x - b.pos.x;
                      const dy = p.pos.y - b.pos.y;
                      const distSq = dx*dx + dy*dy;
                      if (distSq < radiusSq && distSq > 100) {
                          const dist = Math.sqrt(distSq);
                          const force = (1 - dist / (config.drawerAttractionRadius || 100)) * strength * repulsion;
                          b.vel.x += (dx / dist) * force;
                          b.vel.y += (dy / dist) * force;
                      }
                  }
              });
          });
      }
  }
};
